
// TODO: Add at the level of display_labels for sites descriptions when api is ready
//      descriptions {
//          description
//          locale
//      }
export const SITES_QUERY = `
query SitesQuery {
    sites {
        id
        display_labels {
            label
            locale
        }
        registrations {
            id
            offers {
                offer_start_dttm_utc
                offer_end_dttm_utc
                offer_value {
                    unit
                    value
                }
                program {
                    id
                    display_labels {
                        label
                        locale
                    }
                    default_locale
                }
            }
        }
    }
}
`;
